'use client';

import { FC, PropsWithChildren, useState } from 'react';

import { Customer } from '@ravago/shared/page-data/models/features';
import { CustomerSwitchDialog } from '@ravago/shared/page-elements-radiance/components/shared/customer-switch-dialog/customer-switch-dialog';
import { useConfigContext } from '@ravago/shared/page-elements-radiance/hooks/use-config-context';
import { DataTestSelector } from '@ravago/shared/page-elements-radiance/utils/format/format.utils';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { IconButton } from '@ravago/shared/radiance/components/button/components/IconButton/IconButton';
import { Header } from '@ravago/shared/radiance/components/header/components/Header/Header';
import { NavBar } from '@ravago/shared/radiance/components/navigation/components/NavBar/NavBar';
import { useBreakpoint } from '@ravago/shared/radiance/hooks/useBreakpoint/useBreakpoint';
import { NotificationProvider } from '@ravago/shared/radiance/providers/notifications/NotificationProvider';

import { Country, Language } from '../../../services/contentful/locale.service';
import CountryLanguageMenu from '../navbar/components/country-language-menu';

interface Props extends PropsWithChildren {
  locale: string;
  availableLanguages: Array<Language>;
  availableCountries: Array<Country>;
  currentCustomer: Customer | undefined;
}

const EnableCustomerHandler: FC<Props> = ({ children, locale, availableLanguages, availableCountries, currentCustomer }) => {
  const { okta, linkLegacyDigitalPlatform, isPublic } = useConfigContext();

  const { phone } = useBreakpoint();

  const [countryLanguageMenuOpen, setCountryLanguageMenuOpen] = useState(false);

  if (currentCustomer?.customerPortalEnabled === false) {
    return (
      <>
        <NotificationProvider
          containerStyle={{
            zIndex: 0,
            bottom: 80
          }}
        />
        <Header
          sticky
          expanded={countryLanguageMenuOpen ? 'right' : 'none'}
          toolbars={
            <NavBar
              size="large"
              showGutter={false}
              right={
                (availableCountries.length > 1 || availableLanguages.length > 1 || (!isPublic && linkLegacyDigitalPlatform && okta)) && (
                  <Box items="center" gap="xs" height="100%" spacing={{ right: 'lg' }}>
                    <IconButton attributes={{ ...DataTestSelector('navbar-country-language-trigger') }} icon="globe" onClick={() => setCountryLanguageMenuOpen((current) => !current)} />
                  </Box>
                )
              }
            />
          }
          rightCollapse={{
            body: countryLanguageMenuOpen && <CountryLanguageMenu locale={locale} availableCountries={availableCountries} availableLanguages={availableLanguages} />,
            fullWidth: phone
          }}
        />
        <CustomerSwitchDialog open currentCustomer={currentCustomer} />
      </>
    );
  }
  return children;
};

export default EnableCustomerHandler;
